<app-drop-down-section title="{{ 'admin.bimestrale_summary' | transloco }}" [defaultOpen]="false">
    <app-edit-cancel-button header-actions [isEditing]="isEditingBimestrale" [isSaving]="savingBimestrale"
        (edit)="editBimestrale()" (cancel)="cancelEditBimestrale()"
        (save)="saveBimestraleData()"></app-edit-cancel-button>

    <table class="table w-full">
        <thead class="bg-neutral-100 text-neutral-700 uppercase">
            <tr class="max-h-[50px]">
                <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' | transloco }}</th>
                <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' | transloco }}</th>
            </tr>
        </thead>
        <tbody>
            <!-- Period type (read-only) -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'admin.period_type' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <span class="badge badge-sm bg-purple text-white px-3 py-2">
                        {{ bimestraleData!.invoice_period_type }}
                    </span>
                </td>
            </tr>

            <!-- Period start -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'admin.period_start' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimPeriodStart" inputType="text"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.for_period_start">
                        </app-labeled-input>
                    </div>
                </td>
            </tr>

            <!-- Period end -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'admin.period_end' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimPeriodEnd" inputType="text"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.for_period_end">
                        </app-labeled-input>
                    </div>
                </td>
            </tr>

            <!-- Invoice number -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.number' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimInvoiceNumber" inputType="text"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.invoice_number"
                            (inputValueChange)="syncFieldToInvoices('invoice_number', $event)">
                        </app-labeled-input>
                    </div>
                </td>
            </tr>

            <!-- Supplier name -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'shared.labels.electricity.supplier' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimSupplierName" inputType="text"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.supplier_name"
                            (inputValueChange)="syncFieldToInvoices('supplier_name', $event)">
                        </app-labeled-input>
                    </div>
                </td>
            </tr>

            <!-- Total consumption -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.total_consumption' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimTotalConsumption"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.total_consumption">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Invoice amount net -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.amount_actual' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimAmountNet"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.invoice_amount_net_actual">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Invoice amount gross -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.amount_gross' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimAmountGross"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.invoice_amount_gross_actual">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- VAT rate -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.vat_rate' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimVatRate"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.vat_rate">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- VAT amount -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.vat_amount' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimVatAmount"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.vat_amount_actual">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Additional charges -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.additional_charges' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimAdditionalCharges"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.additional_charges">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Total discount -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.total_discount' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimTotalDiscount"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.total_discount_amount">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- TMS charges -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.tms_charges' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimTmsCharges"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.tms_charges">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Total taxes -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.total_taxes' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimTotalTaxes"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.total_taxes">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>

            <!-- Nontaxable amount -->
            <tr class="max-h-[50px]">
                <td class="border-b border-border px-4 py-4">
                    <p>{{ 'invoice.labels.nontaxable_amount' | transloco }}</p>
                </td>
                <td class="border-b border-border px-4 py-4">
                    <div class="min-w-[250px]">
                        <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                            [isDisabled]="!isEditingBimestrale" inputId="bimNontaxableAmount"
                            autoMarginTop="mt-0" [(inputValue)]="editedBimestrale.nontaxable_amount">
                        </app-custom-number-input>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</app-drop-down-section>
